import { get, pick } from "lodash";
import { persistReducer } from "redux-persist";
import { encryptTransform } from "redux-persist-transform-encrypt";
import storage from "redux-persist/lib/storage";

export const __actionTypes = {
  SET_DATA: "[SET_DATA] Action",
  RESET_DATA: "[RESET_DATA] Action",
};

const __initialState = {
  data: undefined,
};

export const reducer = persistReducer(
  {
    storage,
    key: "auth",
    blacklist: [],
    transforms: [
      encryptTransform({
        secretKey: process.env.REACT_APP_STORAGE_ENCRYPTION_KEY,
        onError: function (error) {
          console.log("ERROR :: RERSIST -> TRANSFORM -> ENCRYPT -> ", error);
        },
      }),
    ],
  },
  (state = __initialState, action) => {
    switch (action.type) {
      case __actionTypes.SET_DATA: {
        const data = action.payload;
        let payload = pick(data, [
          "accessToken",
          "accessTokenExpiresAt",
          "idToken",
          "idTokenExpiresAt",
          "refreshToken",
        ]);

        if (get(data, "user")) {
          payload = { ...payload, ...data.user };
        }

        return { data: payload };
      }

      case __actionTypes.SET_AUTHTOKENS: {
        const data = action.payload;
        return { data: { ...state.data, ...data } };
      }

      case __actionTypes.RESET_DATA: {
        return { data: undefined };
      }

      default:
        return state;
    }
  }
);

export const AuthActions = {
  SET_DATA: (payload) => ({ type: __actionTypes.SET_DATA, payload }),
  SET_AUTHTOKENS: (payload) => ({
    type: __actionTypes.SET_AUTHTOKENS,
    payload,
  }),
  RESET_DATA: () => ({ type: __actionTypes.RESET_DATA }),
};
